var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.RecommendCourse.imagesH5),expression:"RecommendCourse.imagesH5"}],class:_vm.filePlayer ? 'file-chat-ad' : 'chat-ad'},[_c('img',{attrs:{"src":_vm.RecommendCourse.imagesH5,"alt":""},on:{"click":_vm.jumpAd}})])
}
var staticRenderFns = []

export { render, staticRenderFns }